import { useTranslation } from 'react-i18next';
import PublicLayout from './PublicLayout';

export default function PrivacyPage() {
  const { t } = useTranslation();

  return (
    <PublicLayout>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">{t('privacy.title')}</h1>
        <p className="text-gray-500 mb-12">{t('privacy.lastUpdated')}</p>

        <div className="prose prose-lg max-w-none space-y-8">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('privacy.section1Title')}</h2>
            <p className="text-gray-600 leading-relaxed">{t('privacy.section1Text')}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('privacy.section2Title')}</h2>
            <p className="text-gray-600 leading-relaxed mb-3">{t('privacy.section2Intro')}</p>
            <ul className="space-y-2 text-gray-600">
              <li className="flex items-start gap-2"><span className="text-blue-600 mt-1">&#8226;</span> <span><strong>{t('privacy.section2Item1Label')}</strong> {t('privacy.section2Item1Text')}</span></li>
              <li className="flex items-start gap-2"><span className="text-blue-600 mt-1">&#8226;</span> <span><strong>{t('privacy.section2Item2Label')}</strong> {t('privacy.section2Item2Text')}</span></li>
              <li className="flex items-start gap-2"><span className="text-blue-600 mt-1">&#8226;</span> <span><strong>{t('privacy.section2Item3Label')}</strong> {t('privacy.section2Item3Text')}</span></li>
              <li className="flex items-start gap-2"><span className="text-blue-600 mt-1">&#8226;</span> <span><strong>{t('privacy.section2Item4Label')}</strong> {t('privacy.section2Item4Text')}</span></li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('privacy.section3Title')}</h2>
            <p className="text-gray-600 leading-relaxed">{t('privacy.section3Intro')}</p>
            <ul className="space-y-2 text-gray-600 mt-3">
              <li className="flex items-start gap-2"><span className="text-blue-600 mt-1">&#8226;</span> {t('privacy.section3Item1')}</li>
              <li className="flex items-start gap-2"><span className="text-blue-600 mt-1">&#8226;</span> {t('privacy.section3Item2')}</li>
              <li className="flex items-start gap-2"><span className="text-blue-600 mt-1">&#8226;</span> {t('privacy.section3Item3')}</li>
              <li className="flex items-start gap-2"><span className="text-blue-600 mt-1">&#8226;</span> {t('privacy.section3Item4')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('privacy.section4Title')}</h2>
            <p className="text-gray-600 leading-relaxed">{t('privacy.section4Text')}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('privacy.section5Title')}</h2>
            <p className="text-gray-600 leading-relaxed">{t('privacy.section5Text')}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('privacy.section6Title')}</h2>
            <p className="text-gray-600 leading-relaxed">{t('privacy.section6Intro')}</p>
            <ul className="space-y-2 text-gray-600 mt-3">
              <li className="flex items-start gap-2"><span className="text-blue-600 mt-1">&#8226;</span> {t('privacy.section6Item1')}</li>
              <li className="flex items-start gap-2"><span className="text-blue-600 mt-1">&#8226;</span> {t('privacy.section6Item2')}</li>
              <li className="flex items-start gap-2"><span className="text-blue-600 mt-1">&#8226;</span> {t('privacy.section6Item3')}</li>
              <li className="flex items-start gap-2"><span className="text-blue-600 mt-1">&#8226;</span> {t('privacy.section6Item4')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('privacy.section7Title')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('privacy.section7Text')}{' '}
              <a href="mailto:privacy@ai-ia.dev" className="text-blue-600 hover:underline">privacy@ai-ia.dev</a>
            </p>
          </section>
        </div>
      </div>
    </PublicLayout>
  );
}
